/**
 * @fileoverview Ajudantes das telas de entrada: o código do link enviado por
 * e-mail (fica depois do #, que não vai ao servidor; lido uma vez e tirado do
 * endereço, para não ficar na barra nem no histórico) e o texto dos erros do
 * servidor.
 */

import { i18n } from "../../translate/i18n";

export const takeLinkCode = () => {
  const match = window.location.hash.match(/code=([0-9a-f]{64})/);
  if (window.location.hash) window.history.replaceState(null, "", window.location.pathname + window.location.search);
  return match ? match[1] : null;
};

export const errorCode = (err) => err?.response?.data?.error || (err?.response?.status === 429 ? "ERR_TOO_MANY_AUTH_ATTEMPTS" : null);

export const errorText = (err) => {
  const code = errorCode(err);
  return code && i18n.exists(`backendErrors.${code}`) ? i18n.t(`backendErrors.${code}`) : i18n.t("auth.errors.generic");
};

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// A confirmação do e-mail avisa as outras abas abertas (a faixa some nelas).
export const EMAIL_CONFIRMED_KEY = "sttelar:email-confirmed";
export const announceEmailConfirmed = () => {
  try {
    localStorage.setItem(EMAIL_CONFIRMED_KEY, String(Date.now()));
  } catch (err) {
    // Sem o armazenamento do navegador, as outras abas atualizam ao recarregar.
  }
};

// O código do navegador do cadastro: com o link do e-mail, faz a pessoa entrar
// direto neste navegador. Sem ele (outro navegador, sem o armazenamento), a
// confirmação vale do mesmo jeito e a tela de entrada pede a senha.
const SIGNUP_BROWSER_KEY = "sttelar:signup-browser";
export const saveSignupBrowser = (proof) => {
  try {
    if (proof) localStorage.setItem(SIGNUP_BROWSER_KEY, proof);
  } catch (err) {
    // Sem o armazenamento do navegador, a pessoa entra com a senha.
  }
};
export const readSignupBrowser = () => {
  try {
    return localStorage.getItem(SIGNUP_BROWSER_KEY);
  } catch (err) {
    return null;
  }
};
export const forgetSignupBrowser = () => {
  try {
    localStorage.removeItem(SIGNUP_BROWSER_KEY);
  } catch (err) {
    // Sem o armazenamento do navegador, não há o que esquecer.
  }
};
